module.exports = __webpack_public_path__ + "img/login_logo.1bd98e5a.svg";